import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { auditLogHelpers } from '@/shared/lib/audit-log'

export const Route = createFileRoute('/settings')({
    component: AdminSettings,
})

function AdminSettings() {
    const { t } = useTranslation()

    // Track settings view
    useEffect(() => {
        auditLogHelpers.trackView('system', 'settings', t('audit.view.settings')).catch(() => {})
    }, [t])

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-3xl font-bold">Settings</h1>
                <p className="text-muted-foreground mt-2">Configure system settings and preferences</p>
            </div>
            <div className="rounded-lg border bg-card p-6">
                <p className="text-sm text-muted-foreground">Settings interface will be displayed here</p>
            </div>
        </div>
    )
}
